










import {
  ExpressionNodeTree,
  IServiceComputationNode,
  convertExpressionTreeToNodeList,
  convertNodeListToExpressionTree,
  ServiceComputationNodeFieldError
} from '@/models';
import Vue, { PropType } from 'vue';

import ComputationExpressionTree from './ComputationExpressionTree.vue';

export default Vue.extend({
  components: {
    ComputationExpressionTree
  },

  name: 'ComputationTreeView',

  props: {
    value: {
      required: false,
      type: Array as PropType<IServiceComputationNode[]>,
      default: () => []
    },

    fieldErrors: {
      required: false,
      type: Array as PropType<ServiceComputationNodeFieldError[]>,
      default: () => []
    }
  },

  data() {
    return {
      internalLazyValue: this.value
    };
  },

  computed: {
    internalValue: {
      get(): ExpressionNodeTree {
        return convertNodeListToExpressionTree(this.internalLazyValue);
      },
      set(val: ExpressionNodeTree) {
        const newValue = convertExpressionTreeToNodeList(val);
        // update node list indicies
        newValue.map((node, index) => {
          node.order = index + 1;
        });

        if (newValue === this.internalLazyValue) return;

        this.internalLazyValue = newValue;

        // hack for passing multiple function on the emit values
        this.$emit('input', newValue);
      }
    }
  },

  watch: {
    value: {
      handler(val) {
        this.internalLazyValue = val;
      },
      deep: true
    }
  },

  methods: {
    updateErrorState(value: boolean) {
      this.$emit('updateErrorState', !value);
    }
  }
});
